export const heroHeaderMaxZIndex = 201;

export const stickyCtaZIndex = heroHeaderMaxZIndex + 1;

export const stickyBannerZIndex = heroHeaderMaxZIndex + 1;

export const reviewDrawerZIndex = stickyBannerZIndex + 1;

export const modalZIndex = 2001;
